// extracted by mini-css-extract-plugin
export default {"price":"Price_price__BOwFJ","currency":"Price_currency__PQz-H","amount":"Price_amount__NvMlo"};